"use strict";
window._theme = window._theme || {};

document.addEventListener('DOMContentLoaded', function() {

  _theme.initSlickSlider($('.aboutus2-slider'),{
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 3.3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2.7,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          arrows: false,
          infinite: true,
          dots: true,
          speed: 5000
        }
      }
    ]
  });
  var maxHeight = 0;
  $('.aboutUs2-slide').each(function(){
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $('.aboutUs2-slide').css('height', maxHeight + 174 + 'px');
  _theme.initSlickSlider($('#aboutUs4Slider'), {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    appendDots: '.aboutus4-slider-dots',
    customPaging: function(slider, i) {
      return '<button type="button"></button>';
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: true
        }
      }
    ]
  });

  const playButtonDesktop = document.getElementById('playButtonDesktop');
  const playButtonDMobile = document.getElementById('playButtonDMobile');
  const videoDesktop = document.getElementById('aboutUsVideoDesktop');
  const videoMobile = document.getElementById('aboutUsVideoMobile');

  // Show only the appropriate play button based on screen size
  const updatePlayButtonVisibility = () => {
    const isMobile = window.innerWidth <= 768; // You can adjust this breakpoint

    if (isMobile) {
      playButtonDMobile.style.display = 'flex';
      playButtonDesktop.style.display = 'none';
    } else {
      playButtonDesktop.style.display = 'flex';
      playButtonDMobile.style.display = 'none';
    }
  };

  const hideAllPlayButtons = () => {
    playButtonDesktop.style.display = 'none';
    playButtonDMobile.style.display = 'none';
  };

  const handleDesktopPlay = () => {
    videoDesktop.play().catch(err => console.error("Desktop play error:", err));
    videoMobile.pause();
    hideAllPlayButtons();
  };

  const handleMobilePlay = () => {
    videoMobile.play().catch(err => console.error("Mobile play error:", err));
    videoDesktop.pause();
    hideAllPlayButtons();
  };

  // Restore play buttons on pause or end
  const showRelevantPlayButton = () => {
    updatePlayButtonVisibility();
  };

  if (playButtonDesktop && playButtonDMobile && videoDesktop && videoMobile) {
    playButtonDesktop.addEventListener('click', handleDesktopPlay);
    playButtonDMobile.addEventListener('click', handleMobilePlay);

    videoDesktop.addEventListener('pause', showRelevantPlayButton);
    videoDesktop.addEventListener('ended', showRelevantPlayButton);

    videoMobile.addEventListener('pause', showRelevantPlayButton);
    videoMobile.addEventListener('ended', showRelevantPlayButton);

    // Initial button visibility setup
    updatePlayButtonVisibility();

    // Update visibility on resize (optional but recommended)
    window.addEventListener('resize', updatePlayButtonVisibility);
  }

  const viewMoreBtns = document.querySelectorAll('.view-more-btn');
  viewMoreBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const container = this.closest('.aboutus3-grid-item');
      container.classList.toggle('active');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      
      this.setAttribute('aria-label', this.getAttribute('aria-expanded') === 'true' ? 'Close' : `View more ${this.closest('.aboutus3-grid-item').querySelector('.aboutus3-grid-item-title').textContent}`);
      
    });
  });
});


window._theme = window._theme || {}; 
const transcriptModalBtn = document.querySelector('.transcript-modal-btn')
const transcriptModalBox = document.querySelector('.transcript-modal')
const transcriptCloseModalBox = document.querySelector('.close-transcript-modal')
transcriptModalBtn.addEventListener('click',()=>{
  transcriptModalBox.classList.add('active');
  if(_theme.isMobile) {
    $('*').not($('.transcript-modal').find('*')).not('.transcript-modal').not($('.transcript-modal').parents()).attr('aria-hidden','true');
    }
  _theme.focusTrap($('.transcript-modal'),function(){
      $('.close-transcript-modal').focus();
  })
  document.querySelector('body').classList.add('transcript-modal-open')
  _theme.toggleOverlay(1)
})
transcriptCloseModalBox.addEventListener('click',()=>{
  transcriptModalBox.classList.remove('active')
  if(_theme.isMobile) {
    $('*').not($('.transcript-modal').find('*')).not('.transcript-modal').not($('.transcript-modal').parents()).removeAttr('aria-hidden','true');
    }
  _theme.toggleOverlay(0)
  document.querySelector('body').classList.remove('transcript-modal-open')
})

